import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import ErrorBoundary from "./ErrorBoundary";
import 'animate.css';
import 'swiper/swiper-bundle.min.css';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistProvider>
        <App />
      </PersistProvider>
    </Provider>
  </ErrorBoundary>
);

// Register the self-uninstalling service worker which clears all old caches.
// This fixes the "must clear cookies on mobile" issue caused by stale cached assets.
serviceWorkerRegistration.register();

// Also run unregister to clear any lingering old service workers and caches
serviceWorkerRegistration.unregister();
